module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9624.2f716129.jpg";